<template>
  <div class="d-flex-wl container-file-mang">
    <div
      :class="[
        'container-actions-file',
        { dragging: userInteractions.isDragging }
      ]"
      @drop.prevent="handleDrop"
      @dragover.prevent="handleDragOver"
      @dragleave.prevent="handleDragLeave"
    >
      <i style="font-size: 18px;" class="fa fa-file-o"></i>
      <p class="txt-no-mrg">Drag and drop file or</p>
      <!-- Input file -->
      <div>
        <input
          type="file"
          name="file"
          id="file"
          class="inputfile"
          ref="file"
          @change="handleSelectFile()"
        />
        <label for="file">Choose file to upload</label>
      </div>
      <!-- Choose file -->
      <div class="file-selected" v-if="formatVars.selectedFileName">
        {{ formatVars.selectedFileName }}
        <i class="fa fa-times" @click="removeSelectedFile"></i>
      </div>
    </div>
    <!-- Button upload -->
    <div class="container-btn-upload-blue">
      <button
        @click="handleFileUpload"
        class="btn btn-home"
        :class="!isValidUpload ? 'btn-disabled' : ''"
      >
        Upload
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileManager",
  props: {
    fileName: { required: true, default: "" },
    isValidUpload: { required: true, default: false }
  },
  data() {
    return {
      formatVars: {
        selectedFileName: null,
        selectedFile: null
      },
      userInteractions: {
        isDragging: false
      }
    };
  },
  watch: {
    fileName: {
      handler() {
        this.removeSelectedFile();
      },
      deep: true
    }
  },
  methods: {
    handleDragOver(e) {
      e.preventDefault();
      Object.assign(this.userInteractions, {
        isDragging: true
      });
    },
    handleDragLeave(e) {
      e.preventDefault();
      Object.assign(this.userInteractions, {
        isDragging: false
      });
    },
    handleDrop(e) {
      e.preventDefault();
      Object.assign(this.userInteractions, {
        isDragging: false
      });
      const file = e.dataTransfer.files[0];
      this.formatVars.selectedFileName = file.name;
      this.formatVars.selectedFile = file;
      this.$emit("handleSelectFile", this.formatVars.selectedFile);
    },
    removeSelectedFile() {
      this.formatVars.selectedFileName = null;
      this.formatVars.selectedFile = null;
      this.$refs.file.value = "";
      this.$emit("handleSelectFile", "");
    },
    handleSelectFile() {
      this.formatVars.selectedFileName = this.$refs.file.files[0].name;
      this.formatVars.selectedFile = this.$refs.file.files[0];
      this.$emit("handleSelectFile", this.formatVars.selectedFile);
    },
    handleFileUpload() {
      if (this.isValidUpload) {
        this.$emit("onFileUpload", this.formatVars.selectedFile);
        this.$emit("handleFileUpload", this.isValidUpload);
        setTimeout(() => {
          this.removeSelectedFile();
        }, 250);
      } else {
        this.$emit("handleFileUpload", this.isValidUpload);
      }
    }
  }
};
</script>
